export function formatFecha(dateStr) {
  if (!dateStr) return '—';
  const [year, month, day] = String(dateStr).slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatPorcentaje(value) {
  return `${(value * 100).toFixed(1)}%`;
}
